// API Service para ECP Capital
// Em produção (app e API no mesmo domínio), usar caminho relativo
const API_BASE_URL = (import.meta.env.VITE_API_URL ?? '').trim();

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;

    // Obter token do localStorage
    const token = localStorage.getItem('ecf_token');

    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        let errorData = null;
        try {
          errorData = await response.json();
        } catch {
          // Response doesn't have JSON body
        }

        const error = new Error(`HTTP error! status: ${response.status}`);
        error.response = { status: response.status, data: errorData };
        throw error;
      }

      // Check if response has content (avoid parsing empty 204 responses)
      if (response.status === 204 || response.headers.get('content-length') === '0') {
        return null;
      }

      const data = await response.json();
      return data;
    } catch (error) {
      // API request error handled by caller
      throw error;
    }
  }


  async download(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const token = localStorage.getItem('ecf_token');

    const config = {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
      method: 'GET',
      ...options,
    };

    const response = await fetch(url, config);

    if (!response.ok) {
      let errorData = null;
      try {
        errorData = await response.json();
      } catch {
        // Response doesn't have JSON body
      }

      const error = new Error(`HTTP error! status: ${response.status}`);
      error.response = { status: response.status, data: errorData };
      throw error;
    }

    const blob = await response.blob();
    const disposition = response.headers.get('content-disposition') || '';
    const match = disposition.match(/filename="?([^";]+)"?/i);

    return {
      blob,
      filename: match?.[1] || null,
      contentType: response.headers.get('content-type') || blob.type,
    };
  }

  // GET request
  async get(endpoint, options = {}) {
    return this.request(endpoint, {
      method: 'GET',
      ...options,
    });
  }

  // POST request
  async post(endpoint, data = {}, options = {}) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data ?? {}),
      ...options,
    });
  }

  // PUT request
  async put(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
      ...options,
    });
  }

  // DELETE request
  async delete(endpoint, options = {}) {
    return this.request(endpoint, {
      method: 'DELETE',
      ...options,
    });
  }
}

export default new ApiService();
